import { createSvgComponent } from "../../icon/createSvgComponent";
import PhoneFill from "@core/icon/assets/phone-fill.svg";
export default createSvgComponent(PhoneFill);